import { ColumnsType } from '@seiue/ui'
import humps from 'humps'

import {
  FieldDomainEnum,
  FieldRespond,
  InformalReflection,
} from 'packages/sdks-next/growp'
import { AnyType } from 'packages/types'

import { formatPrivateInfo } from '@/features/activities/pages/Detail/ReflectionList/utils'
import { FieldRespondWithData } from '@/uikit'

import { ColumnsRender } from './ColumnsRender'

/**
 * 获取表格列
 *
 * @param props - 参数
 * @param props.fields - 表单
 * @param props.domain - 域
 * @param props.hasLeft - 是否有左侧
 * @returns 表格列
 */
export const useStudentColumns = ({
  fields,
  domain,
  hasLeft,
}: {
  fields: FieldRespond[]
  domain: FieldDomainEnum
  hasLeft?: boolean
}) => {
  const columns: ColumnsType<InformalReflection> = fields
    .filter((i: FieldRespondWithData) => {
      const { originLabel } = i.metadata || {}
      if (
        ['avatar'].includes(originLabel || '') ||
        ([
          FieldDomainEnum.FormalStudent,
          FieldDomainEnum.FormalTeacher,
        ].includes(domain) &&
          originLabel === 'activity_names')
      ) {
        return false
      }
      if (
        [
          FieldDomainEnum.InformalStudent,
          FieldDomainEnum.InformalTeacher,
        ].includes(domain) &&
        originLabel === 'account'
      ) {
        return false
      }
      return hasLeft ? i.archivedIsShow : i.isShow
    })
    .sort((a, b) =>
      hasLeft
        ? (a?.archivedWeight || 0) - (b?.archivedWeight || 0)
        : a.weight - b.weight
    )
    .map((i: FieldRespondWithData) => {
      const { originLabel } = i.metadata || {}
      return {
        title: i.label,
        key: humps.camelize(originLabel || i.name),
        dataIndex: humps.camelize(originLabel || i.name),
        width: 150,
        render: (text: AnyType, record: InformalReflection) => {
          if (['account', 'idcard'].includes(i.name)) {
            return formatPrivateInfo(text)
          } else if (i.name === 'phone') {
            return formatPrivateInfo(text, false)
          } else {
            return (
              <ColumnsRender
                field={i}
                text={text}
                record={record}
              />
            )
          }
        },
      }
    })
  return columns
}
